import React from "react";
import { FaCalendarPlus } from "react-icons/fa";

function EventsEmptyState({ onCreate }) {
  return (
    <div className="rounded-[2rem] border border-slate-200 bg-white p-6 text-center shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-3xl bg-orange-100 text-orange-700 dark:bg-orange-500/10 dark:text-orange-200">
        <FaCalendarPlus className="text-2xl" />
      </div>

      <h2 className="mt-5 font-titre text-2xl font-bold text-slate-950 dark:text-white">
        Aucun événement trouvé
      </h2>

      <p className="mx-auto mt-3 max-w-xl text-sm font-medium leading-7 text-slate-600 dark:text-white/55">
        Aucun événement ne correspond à vos filtres ou aucun événement n’est
        encore rattaché à ce judoka.
      </p>

      <button
        type="button"
        onClick={onCreate}
        className="mt-6 inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl bg-gradient-to-r from-blue-600 to-orange-500 px-5 py-3 text-sm font-bold text-white shadow-lg shadow-orange-500/20 transition hover:-translate-y-0.5"
      >
        <FaCalendarPlus />
        Créer un événement
      </button>
    </div>
  );
}

export default EventsEmptyState;